<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle">What Is This Thing Called Love?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle02.vue?41d8606f